import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from './util';
const Icon = (_jsx("svg", Object.assign({ width: "12", height: "22", viewBox: "0 0 12 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M11 1L2 11L11 21", stroke: "currentColor", strokeWidth: "2" }, void 0) }), void 0));
export const variants = {
    default: Icon,
};
export default withVariants(variants);
